/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateOrUpdateRecoveringCharacteristicDto } from '../../models/create-or-update-recovering-characteristic-dto';
import { RecoveringCharacteristic } from '../../models/recovering-characteristic';

export interface CreateOneBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic$Params {
      body: CreateOrUpdateRecoveringCharacteristicDto
}

export function createOneBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic(http: HttpClient, rootUrl: string, params: CreateOneBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveringCharacteristic>> {
  const rb = new RequestBuilder(rootUrl, createOneBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RecoveringCharacteristic>;
    })
  );
}

createOneBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic.PATH = '/api/mgmt/recovering-characteristic';
